import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const Price = styled.div`
  font-size: 22px;
  font-weight: 700;
`

export const DiscountPrice = styled(Price)`
  color: ${myPalette.blue.main};
`

export const OldPrice = styled.div`
  text-decoration: line-through;
  color: ${myPalette.mutedText.main};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`

export const PriceWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex-direction: column;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`
